export default __webpack_public_path__ + "static/media/Die_4.c3ebe1df.png";